import { OrderBookingMode, OrderType } from '@vista-digital/ocapi-types/v1';
import { configurationSettings } from '../../../../configuration';
import { getOrderBookingMode } from './get-order-booking-mode';
import { getOrderType } from './get-order-type';
/**
 * Whether or not a booking fee applies to the current order in progress.
 */
export const isBookingFeeApplicableToOrder = () => {
    // Booking fees only apply to standard orders.
    // Show booking fees if the orderType is undefined (order hasn't been created).
    const orderType = getOrderType();
    if (!!orderType && orderType !== OrderType.Standard)
        return false;
    const { isBookingFeeApplicableToUnpaidBookings } = configurationSettings.data.order;
    return getOrderBookingMode() === OrderBookingMode.Paid || isBookingFeeApplicableToUnpaidBookings;
};
